<template>
  <div id="site-content" class="content" :class="{home: item.is_home}" v-if="item">
    <div class="data_show" v-if="item && item.data_show">
      <h2>
        <i class="fas fa-code"></i>&nbsp;Zrzut danych:
      </h2>
      <pre>{{ item.data_show }}</pre>
    </div>
    <div class="title-wrapper">
      <div class="edit-link" v-if="item.editlink" v-html="edit"></div>
      <h1 v-if="!item.is_home" class="post-title" v-html="title"></h1>
    </div>
    <fcwpDefaultContent v-if="item && item.content.html" :content="item.content.html" :item_id="item_id"></fcwpDefaultContent>
    <h2
      v-if="item.content.card_details && item.content.card_details.title"
      class="has-text-align-center cards-title"
    >{{ item.content.card_details.title }}</h2>
    <fcwpSidebarContent
      v-if="item && this.isSidebar() && item.content.cards"
      :content="item.content.cards"
      :editlink="item.editlink"
    ></fcwpSidebarContent>

    <fcwpArchiveContent
      v-if="item && (item.type === 'archive' || item.type === 'news' || item.type === 'code' || item.type === 'children' || item.type === 'page' || item.type === 'child') && !this.isSidebar() && item.content.cards"
      :content="item.content.cards"
      :editlink="item.editlink"
    ></fcwpArchiveContent>
    <div
      v-if="item.content.card_details && item.content.card_details.url_title && item.content.card_details.url"
      class="home-menu-item link-content has-text-align-center cards-more-link"
    >
      <a :href="item.content.card_details.url">{{ item.content.card_details.url_title }}</a>
    </div>
    <fcwpDefaultContent v-if="item && item.content.extra_html" :content="item.content.extra_html" :item_id="item_id"></fcwpDefaultContent>
    <fcwpAdjacent v-if="item && item.adjacent" :adjacent="item.adjacent"></fcwpAdjacent>
  </div>
</template>

<style lang="scss">
.content {
  position: relative;
  background: rgb($tertiary-color);
  padding: 60px 13vw 30px 13vw;
  border: 1.17vw solid rgb($quaternary-color);
  border-top: 0;
  min-height: 60vh;
  .data_show {
    font-size: 15px;
    padding: 20px;
    border-bottom: 1px solid rgb($quinary-color);
    pre {
      overflow: initial;
    }
  }
  h2.cards-title {
    margin: 4rem 0 0 0;
  }
  .cards-more-link {
    margin-bottom: 3rem;
  }
}
@media (max-width: 700px) {
  .content {
    padding: 50px 35px 30px;
  }
}

.home {
  border-bottom: 0;
}

.edit-link,
.post-title {
  display: inline-block;
}

.post-title {
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  hyphens: auto;
}

.edit-link {
  margin-right: 20px;
  font-size: 2.5rem;
}
</style>


<script>
import fcwpSidebarContent from "./content/fcwpSidebarContent.vue";
import fcwpArchiveContent from "./content/fcwpArchiveContent.vue";
import fcwpDefaultContent from "./content/fcwpDefaultContent.vue";
import fcwpAdjacent from "./content/fcwpAdjacent.vue";

export default {
  name: "fcwpContent",
  props: ["item_id", "item", "scripts"],
  components: {
    fcwpSidebarContent,
    fcwpArchiveContent,
    fcwpDefaultContent,
    fcwpAdjacent
  },
  computed: {
    edit: function() {
      var unpublished =
        this.item.status != "publish"
          ? '&nbsp;<i class="fas fa-lock"></i>'
          : "";
      return (
        '<a href="' +
        this.item.editlink +
        '" title="edytuj"><i class="fas fa-edit"></i></a>' +
        unpublished
      );
    },
    title: function() {
      return this.item.title.replace(/\s*\|\s*/, "<br>");
    }
  },
  methods: {
    isSidebar() {
      var sidebar = this.item.content.cards;
      if (
        sidebar &&
        sidebar[0] &&
        sidebar[0].widget &&
        sidebar[0].widget === "m-card"
      )
        return true;
    }
  }
};
</script>